<template>
	<Container>
		<div class="container">
			<div class="tabs">
				<div v-for='item in courses' class="tab" :class='{"active-tab":activeCourse.Code == item.Code}' @click='activeCourse = item'>{{item.Title}}</div>
			</div>
			<div class="cers-box">
				<template v-for='cer in cers' v-if='cer.CCourseId == activeCourse.Id' >
					<p class="title">我的達人卡</p>
					<div class="cer" @click='showCer(cer)'>
						<img :key='cer.CCourseId'   class="cer-img" v-lazysrc="cer.MyCURL" :data-default='require("@/assets/defaultImg.png")' >
					</div>
				</template>
			</div>
			<div class="cers-box" v-if='cers.filter(item=>item.CCourseId == activeCourse.Id).length == 0'>
					<template v-if='activeCourse.Lessons.length'>
						<p class="title">我的達人卡</p>
						<p >隻要再觀看{{activeCourse.Lessons.length}}個課程就能取得達人卡咯~！</p>
					</template>
					<p style="text-align: center;" v-else>敬請期待</p>
			</div>
			<div class="course">
				<div class="content" v-for='course in courses' v-if='course.Lessons.length && course.Code == activeCourse.Code'>
					<p class="title">未通過</p>
					<div class="items">
						<div class="item" v-for='lesson in course.Lessons' :key='lesson.Code'>
							<div class="cover zoom-out">
								<img v-lazysrc="lesson.Pic" :data-default='require("@/assets/defaultImg.png")' alt="" class="cover-img">
								<span class="tag">{{lesson.Flag | lessonStatus}}</span>
								<img @click='goPlay(lesson)' src="@/assets/play.png" alt="" class="play">
							</div>
							<div class="bottom">
								<p class="name">{{lesson.Title}}</p>
								<div @click='goPlay(lesson)' class="button-primary detail">{{lesson.Flag | buttonTitle}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Container>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				cers:[],
				courses:[],
				activeCourse:{},
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		filters: {
			lessonStatus(value){
				if (value <= 0) return '未觀看'
				if (value <= 1) return '學習中'
				return '已看完'
			},
			buttonTitle(value){
				if (value <= 1) return '查看'
				if (value <= 10) return '未考核'
				if (value == 11) return '考核通過'
				if (value == 12) return '考核未通過'
			}
		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getELearnCerAction',
				'getELearnCourseAction',
			]),
			async initData(){
				this.cers = await this.getELearnCerAction()
				let response = await this.getELearnCourseAction({
					QW:'',
					keys:'',
					startIndex:1,
					pageSize:30,
					isCount:10,
					status:1,
				})
				if (response) {
					this.courses = response.Courses
					this.activeCourse = this.courses[0]
				}
			},
			goPlay(lesson){
				this.routerPush({
					path:'/train/detail',
					query:{
						lessonCode:lesson.Code
					},
					params:{
						lesson,
					}
				})
			},
			showCer(cer){
				this.routerPush({
					path:'/train/certificate',
					query:{
						code:cer.MyCCode
					},
					params:{
						cerUrl:cer.MyCURL
					}
				})
			},
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.container {
		width: 85%;
		margin: auto;
		padding-top: 0;
	}
	.title {
		// text-align: center;
		@include fontSize($font-size-20);
		margin:20px 0;
		font-weight: bold;
		strong {
			@include fontSize($font-size-24);
			padding: 0 10px;
			font-weight: normal;
		}
	}
	.tabs {
		display:flex;
		align-items: center;
		justify-content: space-around;
		border-bottom:1px solid #eee;
		margin-top: 40px;
		.tab {
			@include fontSize($font-size-24);
			padding: 10px 20px;
			cursor: pointer;
		}
		.active-tab {
			border-bottom:1px solid $theme-color;
			color:$theme-color;
		}
	}
	.cers-box {
		margin: 40px 0;
		.cer {
			display:flex;
			flex-direction: row;
			cursor: pointer;
		}
	}
	
	.cer-img {
		width:200px;
		height: 282px;
		margin-right: 20px;
		background-color: #eee;
		object-fit: contain;
	}
	.content {
		.title {
			// color:$theme-color;
			// text-align: center;
			@include fontSize($font-size-20);
			font-weight: bold;
		}
		.coming-soon {
			text-align: center;
			padding:80px;
		}
		.items {
			display: flex;
			padding: 20px 0;
			// justify-content: space-between;
			flex-wrap: wrap;
			.item {
				width:18vw;
				margin: 0 0.7vw;
				margin-bottom: 30px;
				border-radius: 10px;
				overflow: hidden;
				box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
				.cover {
					height:11.25vw;
					display: flex;
					justify-content: center;
					align-items: center;
					position:relative;
					cursor: pointer;
					.cover-img {
						width:100%;
						height:100%;
						object-fit: cover;
					}
					.tag {
						position: absolute;
						right: 10px;
						top: 10px;
						background-color: $theme-color;
						color:white;
						padding: 3px 20px;
						border-radius: 20px;
					}
					.play {
						position:absolute;
						width:50px;
						height:50px;
					}
				}
				.bottom {
					display: flex;
					margin: 10px;
					justify-content: space-between;
					align-items: center;
					.detail {
						padding:3px 10px;
						border-radius: 20px;
						min-width:60px;
					}

				}
			}
		}
	}
	@media (max-width: 768px){
		.container {
			width: 95%;
		}
		.content {
			.items {
				.item {
					width: 45vw;
					.cover {
						height:28.125vw;
					}
				}
			}
	}
}
</style>